import React, {useCallback, useEffect, useState} from 'react';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import {makeStyles, createStyles } from '@material-ui/core/styles';
import {push} from "connected-react-router";
import {useDispatch, useSelector} from "react-redux";
import {signOut} from "../../reducks/users/operations";
// import {TextInput} from "../UIkit";
// import IconButton from "@material-ui/core/IconButton";
// import SearchIcon from "@material-ui/icons/Search";
// import AddCircleIcon from '@material-ui/icons/AddCircle';
import HistoryIcon from '@material-ui/icons/History';
// import PersonIcon from '@material-ui/icons/Person';
import HomeIcon from '@material-ui/icons/Home';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import {db} from "../../firebase";
// import {getUserRole} from "../../reducks/users/selectors";

const useStyles = makeStyles((theme) =>
    createStyles({
        drawer: {
            [theme.breakpoints.up('sm')]: {
                width: 256,
                flexShrink: 0,
            }
        },
        // necessary for content to be below app bar
        toolbar: theme.mixins.toolbar,
        drawerPaper: {
            width: 256,
        },
        searchField: {
            alignItems: 'center',
            display: 'flex',
            marginLeft: 32
        }
    }),
);

const GuestDrawer = (props) => {
    const { container } = props;
    const classes = useStyles();
    const dispatch = useDispatch();
    // const selector = useSelector(state  => state)
    // const userRole = getUserRole(selector)
    // const isAdministrator = (userRole === "administrator");

    const selectMenu = (event, path) => {
        dispatch(push(path));
        props.onClose(event);
    };

    // const menus = [
    //     {func: selectMenu, label: "TOP",    icon: <HomeIcon/>,   id: "home",  value: "/"},
    //     {func: selectMenu, label: "ログイン",    icon: <PersonIcon />,   id: "singin",  value: "/signin"},
    //     {func: selectMenu, label: "新規登録",    icon: <PersonIcon />,   id: "signup",  value: "/signup"},
    // ];

    return (
        <nav className={classes.drawer} aria-label="mailbox folders">
            <Drawer
                container={container}
                variant="temporary"
                anchor={"right"}
                open={props.open}
                onClose={(e) => props.onClose(e)}
                onKeyDown={(e) => props.onClose(e)}
                classes={{
                    paper: classes.drawerPaper,
                }}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
            >
                <div>
                    <Divider />
                    <List>
                        <ListItem button key="signin" onClick={() => dispatch(push('/signin'))}>
                            <ListItemIcon><ExitToAppIcon/></ListItemIcon>
                            <ListItemText primary="ログイン" />
                        </ListItem>
                    </List>
                    <List>
                        <ListItem button key="signup" onClick={() => dispatch(push('/signup'))}>
                            <ListItemIcon><ExitToAppIcon/></ListItemIcon>
                            <ListItemText primary="新規登録" />
                        </ListItem>
                    </List>
                    <Divider />
                </div>
            </Drawer>
        </nav>
    );
}

export default GuestDrawer